<footer
  id="dx-global-footer"
  [class.dark-mode]="darkMode"
  class="bl-bg-color--white bl-border-top--solid bl-padding-x--16 bl-padding-x-lg--40 bl-padding-y--16"
>
  <div id="footer-container" class="set-width bl-display--flex bl-margin-x--auto">
    <div id="footer-main-content" class="bl-display--flex bl-flex-direction--column bl-flex--auto bl-padding-right--16">
      <div id="footer-links" class="bl-flex--auto">
        @if (footerLinks) {
          <ul class="bl-display--flex bl-flex-flow--wrap">
            @for (link of footerLinks; track link; let i = $index) {
              <li>
                <a
                  [href]="link.route"
                  target="_blank"
                  rel="noopener"
                  class="bl-text-style--secondary-text-1 bl-font-color--base bl-text-decoration--none"
                >
                  {{ link.label }}</a
                >
                @if (i < footerLinks.length - 1) {
                  <span aria-hidden="true" class="bl-margin-x--8 bl-font-color--silver"> | </span>
                }
              </li>
            }
          </ul>
        }
        <ng-content></ng-content>
      </div>
      <ng-container *ngTemplateOutlet="footerCopyright; context: { mobileLayout: false }"> </ng-container>
    </div>
    <div id="footer-secondary-content" class="bl-text-style--tertiary-text-1">
      <ng-content select="[footer-secondary-content]"></ng-content>
    </div>
  </div>
  <ng-container *ngTemplateOutlet="footerCopyright; context: { mobileLayout: true }"> </ng-container>
</footer>

<ng-template #footerCopyright let-mobileLayout="mobileLayout">
  <p id="footer-copyright-wrapper" class="bl-margin-bottom--0 bl-text-style--tertiary-text-1 bl-margin-top--8"
    [ngClass]="mobileLayout ? 'bl-display-md--none' : 'bl-display--none bl-display-md--block'">
    @if(copyright){
    <span id="footer-copyright" class="bl-margin-right--4" [innerHTML]="'&copy; ' + copyright"></span>
    }
    <span id="footer-powered-by">{{'footer/poweredBy' | dictionary}}</span>
  </p>
</ng-template>